import { jsx } from "react/jsx-runtime";
import { Path, SVG } from "@wordpress/primitives";
var pull_right_default = /* @__PURE__ */ jsx(SVG, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx(Path, { d: "M14 6v12h6V6h-6zM4 10h7V8.5H4V10zm0 5.5h7V14H4v1.5z" }) });
export {
  pull_right_default as default
};
//# sourceMappingURL=pull-right.js.map
